// extracted by mini-css-extract-plugin
module.exports = {"AppLayout":"styles_AppLayout__2oCsF"};